
import { Component, Prop, Vue } from "vue-property-decorator";
import { hasMoreThanTwoDecimals, multiply } from "@/utils/number";

/** 同组产品展示信息 */
export interface DetailQueryQtyStepProductGroupInfo {
  transactionNumber?: string;
  hqNumber?: string;
  jrNumber?: string;
  oeNumber?: string;
  customerNumber?: string;
  refNumber?: string;
  hqProductName?: string;
  qty?: number;
  packingCodes?: string;
}

/** 装箱单产品列表项 */
export interface PackingListProductItem {
  packingListCode?: string;
  unitPrice?: number;
  purchaseQuantityStep?: number;
  productGroup?: DetailQueryQtyStepProductGroupInfo;
}

@Component({
  name: "PackingListProductListDialog",
})
export default class PackingListProductListDialog extends Vue {
  @Prop({ default: false }) private visible!: boolean;
  @Prop({ default: () => [] }) private items!: PackingListProductItem[];
  @Prop({ default: false }) private loading!: boolean;

  get warningRowCount(): number {
    return (this.items || []).filter((row) => this.hasRowWarning(row)).length;
  }

  private getQty(row: PackingListProductItem): number | undefined {
    return row.productGroup && row.productGroup.qty;
  }

  private displayValue(value: number | string | null | undefined): string | number {
    if (value === 0) {
      return 0;
    }
    return value == null || value === "" ? "" : value;
  }

  private isMultipleOf(value: number | string, step: number | string): boolean {
    const v = Number(value);
    const s = Number(step);
    if (!Number.isFinite(v) || !Number.isFinite(s) || s <= 0) {
      return true;
    }
    const ratio = v / s;
    return Math.abs(ratio - Math.round(ratio)) < 1e-8;
  }

  private shouldShowQuantityStepHint(row: PackingListProductItem): boolean {
    const step = Number(row.purchaseQuantityStep);
    return Number.isFinite(step) && step > 1;
  }

  private hasQtyWarning(row: PackingListProductItem): boolean {
    const qty = this.getQty(row);
    const { purchaseQuantityStep } = row;
    if (qty == null || purchaseQuantityStep == null) {
      return false;
    }
    return !this.isMultipleOf(qty, purchaseQuantityStep);
  }

  private getTotalPrice(row: PackingListProductItem): number | "" {
    const qty = this.getQty(row);
    if (qty == null || row.unitPrice == null) {
      return "";
    }
    const qtyNum = Number(qty);
    const unitPrice = Number(row.unitPrice);
    if (!Number.isFinite(qtyNum) || !Number.isFinite(unitPrice)) {
      return "";
    }
    return multiply(qtyNum, unitPrice, 10);
  }

  private hasTotalPriceWarning(row: PackingListProductItem): boolean {
    const totalPrice = this.getTotalPrice(row);
    if (totalPrice === "") {
      return false;
    }
    return hasMoreThanTwoDecimals(totalPrice);
  }

  private hasRowWarning(row: PackingListProductItem): boolean {
    return this.hasQtyWarning(row) || this.hasTotalPriceWarning(row);
  }

  private qtyWarningTip(row: PackingListProductItem): string {
    return `【数量】(${this.getQty(row)})不是【采购计价单位】(${row.purchaseQuantityStep})的倍数，将不能生成计划。`;
  }

  private quantityStepHintTip(row: PackingListProductItem): string {
    return `采购计价单位:${row.purchaseQuantityStep}\n\n注意: 【数量】必须是【采购计价单位】的倍数。因要满足装箱单内单个产品的总价必须要两位小数以内，以能付款给供应商。`;
  }

  private totalPriceWarningTip(row: PackingListProductItem): string {
    return `【总价】(${this.getTotalPrice(row)})不是两位小数，将不能生成计划。`;
  }

  private handleClose() {
    this.$emit("update:visible", false);
  }
}
